<template>
  <el-dialog
      :visible.sync="isVisible"
      custom-class="fifl-dialog member-check-dialog"
      :append-to-body="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div
        slot="title"
        class="member-check-dialog__header"
      >
        <h2>
          {{ title }}
        </h2>
        <span>{{ description }}</span>
      </div>
      <slot />
    </el-dialog>
</template>

<script>
export default {
    name: 'SelfCheckinDialog',
    props:{
        title:{
            type: String,
            default: ''
        },
        description:{
            type: String,
            default: ''
        },
        isFormDialogVisible:{
            type: Boolean,
            default: false, 
        }
    },
    computed:{
        isVisible:{
            get:function(){
                return this.isFormDialogVisible;
            },
            set:function(val){
                this.$emit('close',val);
            }
        }
    },
    methods:{
    }
}
</script>

<style lang='scss'>
.member-check-dialog.fifl-dialog {
	width: 420px;
	height: 520px;
	margin-top: calc(50vh - 260px);
  display: flex;
  flex-direction: column;

	@media screen and (max-width: 768px) {
		width: calc(100% - 20px);
		top: calc(50% - 260px);
	}

	.el-dialog__header {
		padding: 20px;
		padding-bottom: 23px;
	}

	.el-dialog__headerbtn {
		top: 20px;
		right: 20px;
	}

	.el-dialog__body {
		overflow: auto;
		height: 420px;
		padding: 0 20px 0px 20px;
	}

	.member-check-dialog__header {
		h2 {
			font-size: 17px;
			line-height: 24px;
			color: #4a4a4a;
			letter-spacing: -0.79px;
			margin-bottom: 11px;
      @media screen and (max-width: 768px) {
        font-size: 15px;
        line-height: 20px;
	    }
		}

		span {
			font-size: 15px;
			line-height: 22px;
			color: #4a4a4a;
			letter-spacing: -0.79px;
      @media screen and (max-width: 768px) {
        font-size: 13px;
	    }
		}
	}

}
</style>